import { doFetch } from "lib/doFetch";
import { isPublicPath, isExtPath } from "lib/routing";
import { features } from "app/features";
import { saveEvents, loadEvents } from "./persistence";

const ANALYTICS_URL = "/research/japi/usage-analytics/grp-ui-event";
let events = loadEvents();
let timer = null;

export function audit(event) {
  if (!features.analytics || !event) return;
  if (event.payload) event.payload.timestamp = Date.now();

  events.push(event);
  saveEvents(events);
  if (!timer) timer = window.setInterval(postAnalytics, 60000);
}

async function postAnalytics() {
  if (isPublicPath() || !events.length) return;

  var body = {
    source: "GRP",
    beaconId: Math.random().toString(),
    events: events
  };

  try {
    if (isExtPath()) {
      const ucid = sessionStorage.getItem("ext-ucid");
      const extBody = ucid ? { ...body, ucid } : body;

      await fetch(ANALYTICS_URL, {
        method: "POST",
        body: JSON.stringify(extBody),
        headers: { "Content-Type": "application/json" }
      });
    } else {
      await doFetch(ANALYTICS_URL, JSON.stringify(body), "POST");
    }
    events = [];
    saveEvents([]);
  } catch (err) {
    console.warn("Error submitting readership");
    events = [];
    saveEvents([]);
  }
}
